import { render, staticRenderFns } from "./DetailsOfTop-upAndWithdrawal.vue?vue&type=template&id=2563feb3&scoped=true&"
import script from "./DetailsOfTop-upAndWithdrawal.vue?vue&type=script&lang=js&"
export * from "./DetailsOfTop-upAndWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563feb3",
  null
  
)

component.options.__file = "DetailsOfTop-upAndWithdrawal.vue"
export default component.exports